// extracted by mini-css-extract-plugin
export default {"links":"Master_links__Jj8FA"};